import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MicroLoanCustomer } from '../amortization-schedule/amortization-schedule.component';
export interface LoanActionObject {
  type: string;
  id: number;
  customer: MicroLoanCustomer;
}
@Component({
  selector: 'app-loan-report',
  templateUrl: './loan-report.component.html',
  styleUrls: ['./loan-report.component.scss']
})
export class LoanReportComponent implements OnInit {

  constructor() { }
  armoCycles = [
    {name: 'DAILY', code: 1}, {name: 'WEEKLY', code: 2},
    {name: 'FORTNIGHTLY', code: 3}, {name: 'MONTHLY', code: 4},
    {name: 'QUARTERLY', code: 5}, {name: 'HALF YEARLY', code: 6},
    {name: 'ANNUALLY', code: 7}, {name: 'BIANNUALLY', code: 8},
  ];
  @Input() itm: any;
  @Output() loanActions = new EventEmitter<LoanActionObject>();
  @Input() showActions = false;
  ngOnInit(): void {
  }
  emitMicroLoanID(value: LoanActionObject): void {
    this.loanActions.emit(value);
  }
  checkArmotCycle(code: number): string {
    if(code) {
      return this.armoCycles.filter(i => i.code === Number(code))[0].name || "MONTHLY";
    } else return 'MONTHLY'
  }
}
